/**
 * @description 返回有权限的路由
 */
import _ from 'lodash';
import router from './index';
import store from '../store/index';
import { RouteRecordRaw } from 'vue-router';

const MENURESOURCE = 1;

/**
 * @description: 页面路径验证
 * @param {String} url 路径
 */
function validateRoute(url: string) {
  const pathArr = _.chain(url).trim().trimStart('/').split('/').value();
  return pathArr;
}

/**
 * @description: 根据用户权限生成相应的路由表
 * @param {Array<Object>} menus 权限菜单
 * @param {Object} result 递归结果
 */
function genrateRouterMap(menus: [], result = []) {
  _.reduce(
    menus,
    (routerMap, menu) => {
      const frontUrl = _.get(menu, 'frontUrl', '');
      if (frontUrl && frontUrl !== '/') {
        const arr = validateRoute(frontUrl);
        if (!arr) {
          // Message.warning(`${_.get(menu, 'resourceName')}路径配置不符合规则！`);
        } else {
          let routeName = _.camelCase(arr[arr.length - 1]);
          if (arr[0] === 'report') {
            routeName = arr[0];
          }
          routerMap = _.isArray(routerMap) ? routerMap : [];
          routerMap.push({
            name: routeName,
            path: frontUrl,
          });
        }
      } else if (menu.resourceType === MENURESOURCE && _.get(menu, 'subResources', []).length > 0) {
        genrateRouterMap(menu.subResources, routerMap);
      }
      return routerMap;
    },
    result,
  );
  return result;
}

/**
 * @description: 获取权限菜单
 */
const getRoutes = () => {
  const menus = store.getters.authority;
  const routerMap = genrateRouterMap(menus);
  return new Promise((resolve) => {
    resolve(routerMap);
  });
};

/**
 * @description 取得模块有权限的路由 + 模块路由和组件映射关系 = 需要动态添加的路由
 * @param {Object} modules 引入的路由模块
 */
const generateRoutes = (modules: { default: object }) => {
  const routerMap = modules.default;
  return getRoutes().then((data) => {
    return _.map(data, (route) => {
      route.component = routerMap[route.name];
      return route;
    }).filter((route) => route.component);
  });
};

/**
 * @description 注册路由
 * @param {Function} cb 回调函数
 */
const registerRoutes = (cb: unknown) => {
  import('./modules').then((modules) => {
    // generate routes
    generateRoutes(modules).then((appendRoutes) => {
      // register router
      appendRoutes.forEach((item) => {
        router.addRoute(item as unknown as RouteRecordRaw);
      });
      cb && typeof cb === 'function' && cb();
    });
  });
};

export { registerRoutes };
